import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import { getLocations, getVariables } from "@/api";
import { GeoFenceLocation, Variable } from "@/types";

// TODO move variables to a context

export const useVariables = () => {
  const { getAccessTokenSilently } = useAuth0();

  const [variables, setVariables] = useState<Variable[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<boolean | null>(null);

  const client = process.env.REACT_APP_CLIENT || 'core';

  useEffect(() => {
    const fetchVariables = async () => {
      setLoading(true);
      setError(null);

      try {
        const accessToken = await getAccessTokenSilently();
        const { data, error } = await getVariables(accessToken, client);

        if (error) setError(true);

        if (client === 'imedia') {
          const updatedData = data.map(variable => {
            if (variable.tag_type === 'Mindsets') {
              return {...variable, tag_type: 'Audience Library'}
            }
            return variable
          })
          setVariables(updatedData);
        } else {
          setVariables(data);
        }
      } catch (err) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchVariables();
  }, [getAccessTokenSilently]);

  return {
    variables,
    loading,
    error,
  };
};


export const useLocations = () => {
  const { getAccessTokenSilently } = useAuth0();

  const [locations, setLocations] = useState<GeoFenceLocation[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<boolean | null>(null);

  useEffect(() => {
    const fetchLocations = async () => {
      setLoading(true);
      setError(null);

      try {
        const accessToken = await getAccessTokenSilently();
        const { data, error } = await getLocations(accessToken);

        if (error) setError(true);

        setLocations(data);
      } catch (err) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchLocations();
  }, [getAccessTokenSilently]);

  return {
    locations,
    loading,
    error,
  };
};
